/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateUserGlobalGrantsDto } from '../../models/update-user-global-grants-dto';
import { UserGlobalGrantsDto } from '../../models/user-global-grants-dto';

export interface UpdateUserGlobalGrants$Params {
  id: number;
  'X-API-Version'?: string;
      body: UpdateUserGlobalGrantsDto
}

export function updateUserGlobalGrants(http: HttpClient, rootUrl: string, params: UpdateUserGlobalGrants$Params, context?: HttpContext): Observable<StrictHttpResponse<UserGlobalGrantsDto>> {
  const rb = new RequestBuilder(rootUrl, updateUserGlobalGrants.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserGlobalGrantsDto>;
    })
  );
}

updateUserGlobalGrants.PATH = '/api/users/{id}/global-grants';
